export default __webpack_public_path__ + "static/media/msf_m3.75559df2.png";